<layout-default>
    <div header>
        <div toolbar>
            <h4>
                <i-feather name="database"></i-feather> {{'Distribution centers for partner' | translate}}: {{partner.name}}
            </h4>
        </div>

        <div toolbar>
            <button id="partner-dc-btn-create" class="btn btn-sm btn-uppercase btn-white" (click)="createPartnerDc()">
                <i-feather [style.height.px]="23" [style.width.px]="13" class="mg-r-10" name="plus"></i-feather> {{ 'Add distribution center' | translate }}
            </button>
            <div id="partner-dc-btn-search" class="filter-container">
                <div class="phrase-filter">
                    <input type='text' class="list-filter form-control" placeholder="{{'type to search' | translate}}" (keyup)='applyFiltering($event)'/>
                </div>
            </div>
        </div>
        <hr />
    </div>
    
    <div content>
        <div *ngIf="!loader">
            <ngx-datatable 
                id="partner-dc-table" 
                class="bootstrap" 
                [rows]="partnerdcs" 
                [columns]="columns" 
                [columnMode]="'flex'"
                [headerHeight]="50" 
                [footerHeight]="50" 
                [messages]="tableMessages" 
                [rowHeight]="'auto'" 
                [externalPaging]="false"
                [count]="pagable.totalElements" 
                [offset]="page" 
                [rowClass]="rowClass"
                [limit]="size" 
                [scrollbarH]="scrollBarHorizontal"
                (page)="setPage($event)">
                <ng-container *ngFor="let col of columns">
                    <ngx-datatable-column [flexGrow]="col.flexGrow" [prop]="col.prop">
                        <ng-template let-column="column" ngx-datatable-header-template class="header" let-sort="sortFn">
                            <b>{{ col.name | translate }}</b>
                        </ng-template>
                        <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                            <!-- <span *ngIf="isCapacityColumn"></span> -->
                            <div id="partner-table-col-{{col.prop}}" *ngIf="isColumnAddress(col.prop)">{{ value | addressLabelPipe }}</div>
                            <div id="partner-table-col-{{col.prop}}" *ngIf="isColumnTConvertTime(col.prop)">{{ value | secToHoursPipe }}</div>
                            <div id="partner-table-col-{{col.prop}}" *ngIf="!isOptionsColumn(col.prop) && !isColumnAddress(col.prop) && !isColumnTConvertTime(col.prop)">{{ value }}</div>
                            <div id="partner-table-col-{{col.prop}}" *ngIf="isOptionsColumn(col.prop)">
                                <div class="dropdown" dropdown>
                                    <button
                                        class="btn btn-outline-secondary btn-xs dropdown-toggle"
                                        type="button"
                                        id="dropdownMenuButton">
                                        {{ 'Select' | translate }}
                                    </button>

                                    <div class="dropdown-menu dropdown-menu-right div-main-actions">
                                        <a 
                                            id="partner-dc-btn-edit"
                                            class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                            (click)="goToDetails(row.id)">
                                                {{'Edit' | translate }}
                                        </a>

                                        <a 
                                            id="partner-dc-btn-remove"
                                            class="btn btn-outline-secondary btn-sm btn-uppercase dropdown-item" 
                                            (click)="removeDc(row.id)">
                                                {{'Remove' | translate }}
                                        </a>

                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </ngx-datatable-column>
                </ng-container>
            </ngx-datatable>
        </div>

        <div *ngIf="loader" class="load-spinner text-center">
            <i class="fa fa-spinner fast-pulse" aria-hidden="true"></i> {{ 'Please, wait!' | translate }}
        </div>

    </div>

</layout-default>

<ng-template #confirmation>
    <div class="modal-header">
        <h4 class="modal-title">{{'Confirm action' | translate }}</h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="decline()"><span aria-hidden="true">&times;</span></button>
    </div>

    <div class="modal-body text-center">
        <p>{{'Do you confirm remove the distribution center' | translate }}?</p>
        <button type="button" class="btn btn-brand-01" (click)="confirm()">
            {{'Yes, remove' | translate }}
        </button>
        <button type="button" class="btn btn-default" (click)="decline()">{{'Cancel' | translate }}</button>
    </div>
</ng-template>
